export var AuthMode;
(function (AuthMode) {
    AuthMode["LoginForm"] = "login-form";
    AuthMode["RegisterForm"] = "register-form";
    AuthMode["RegisterSuccess"] = "register-sucess";
    AuthMode["NewPasswordForm"] = "new-password-form";
    AuthMode["NewPasswordSuccess"] = "new-password-success";
    AuthMode["PasswordChanged"] = "password-changed";
})(AuthMode || (AuthMode = {}));
